import React, { useEffect } from 'react'
import './Nuts.css'
import Notfound from '../../../../Notfound'
import Breadcrumb from '../../../../../components/Breadcrum';
import InfoContainer from '../../../../../components/InfoContainer';
import Card from '../../../../../components/Card';
const cardData = [
  {
    id: "Almond",
    image: "./assets/img/DryFruits-Nuts/Almonds.jpg",
    title: "Almonds",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Almond',
  },
  {
    id: "Cashew Nuts",
    image: './assets/img/DryFruits-Nuts/Cashew-Nuts.jpg',
    title: "Cashew Nuts",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Cashew',
  },
  {
    id: "Pistachios",
    image: './assets/img/DryFruits-Nuts/Pistachios.jpg',
    title: "Pistachios",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Pistachios',
  },
  {
    id: "Walnuts",
    image: './assets/img/DryFruits-Nuts/Walnuts.jpg',
    title: "Walnuts",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Walnuts',
  },
  {
    id: "Dates",
    image: './assets/img/DryFruits-Nuts/Dates.jpg',
    title: "Dates",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Dates',
  },
  {
    id: "Raisins",
    image: './assets/img/DryFruits-Nuts/Raisins.jpg',
    title: "Raisins",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Raisins',
  },
  {
    id: "Figs",
    image: './assets/img/DryFruits-Nuts/Figs.jpg',
    title: "Figs",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Figs',
  },
  {
    id: "Apricots",
    image: './assets/img/DryFruits-Nuts/Apricots.jpg',
    title: "Apricots",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Apricots',
  },
  {
    id: "Berries & Exotic Dried Fruits",
    image: './assets/img/DryFruits-Nuts/Berries-Exotic-Dried-Fruits.jpg',
    title: "Berries & Exotic Dried Fruits",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Berries',
  },
  {
    id: "Premium Nuts",
    image: './assets/img/DryFruits-Nuts/Premium-Nuts.jpg',
    title: "Premium Nuts",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/PremiumNuts',
  },
  {
    id: "Seeds",
    image: './assets/img/DryFruits-Nuts/Seeds.jpg',
    title: "Seeds",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/Seeds',
  },
  {
    id: "Indian Traditional Products",
    image: './assets/img/DryFruits-Nuts/Indian-Traditional-Products.jpg',
    title: "Indian Traditional Products",
    redirectionUrl: '/business/agricultural-commodities/DryFruits-Nuts/IndianTraditionalProducts',
  },

];
export default function Nuts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Dry Fruits & Nuts"
        backgroundImage='./assets/img/contact-banner.png'
        height="40vh"
      ></Breadcrumb>
      <div className="cardContainer mt-5">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
                <Card
                  key={card.id}
                  image={card.image}
                  title={card.title}
                  id={card.id}
                  description={card.description}
                  redirectionUrl={card.redirectionUrl}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}